import { render, staticRenderFns } from "./DespesaCard.vue?vue&type=template&id=454248cc"
import script from "./DespesaCard.vue?vue&type=script&lang=js"
export * from "./DespesaCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports